<template>
  <section class="section">
    <div class="glass-container animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Reportes Centralizados</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Análisis de ventas, participación y estadísticas globales</p>
          </div>
        </div>
      </div>

      <div class="columns is-multiline">
        <!-- Votos por Ciudad -->
        <div class="column is-4">
          <div class="report-card glass-card">
            <div class="is-flex is-align-items-center mb-4">
              <b-icon icon="map-marker-radius" type="is-primary" size="is-large" class="mr-3" />
              <h2 class="title is-4 has-text-white mb-0">Votos por Ciudad</h2>
            </div>
            <p class="has-text-grey-lighter mb-5">Visualiza la distribución de votos por cada ciudad participante.</p>
            <b-button 
              type="is-primary" 
              expanded 
              class="is-rounded glass-btn"
              @click="$router.push('/graficos-ciudad')"
            >
              Ver Reporte
            </b-button>
          </div>
        </div>

        <!-- Votos por Restaurante -->
        <div class="column is-4">
          <div class="report-card glass-card">
            <div class="is-flex is-align-items-center mb-4">
              <b-icon icon="store" type="is-success" size="is-large" class="mr-3" />
              <h2 class="title is-4 has-text-white mb-0">Votos/Restaurante</h2>
            </div>
            <p class="has-text-grey-lighter mb-5">Ranking de restaurantes más votados y calificación promedio.</p>
            <b-button 
              type="is-success" 
              expanded 
              class="is-rounded glass-btn"
              @click="$router.push('/graficos-vendidos')"
            >
              Ver Reporte
            </b-button>
          </div>
        </div>

        <!-- Informe de Ventas -->
        <div class="column is-4">
          <div class="report-card glass-card">
            <div class="is-flex is-align-items-center mb-4">
              <b-icon icon="finance" type="is-info" size="is-large" class="mr-3" />
              <h2 class="title is-4 has-text-white mb-0">Informe Ventas</h2>
            </div>
            <p class="has-text-grey-lighter mb-5">Resumen detallado de ingresos por productos y eventos.</p>
            <b-button 
              type="is-info" 
              expanded 
              class="is-rounded glass-btn"
              @click="$router.push('/informe-ventas')"
            >
              Ver Reporte
            </b-button>
          </div>
        </div>

        <!-- Nómina de Empleados -->
        <div class="column is-4">
          <div class="report-card glass-card">
            <div class="is-flex is-align-items-center mb-4">
              <b-icon icon="account-group" type="is-warning" size="is-large" class="mr-3" />
              <h2 class="title is-4 has-text-white mb-0">Nómina</h2>
            </div>
            <p class="has-text-grey-lighter mb-5">Gestión de pagos y liquidaciones para el personal operativo.</p>
            <b-button 
              type="is-warning" 
              expanded 
              class="is-rounded glass-btn"
              @click="$router.push('/nomina')"
            >
              Ver Reporte
            </b-button>
          </div>
        </div>

        <!-- Ingresos y Egresos -->
        <div class="column is-4">
          <div class="report-card glass-card">
            <div class="is-flex is-align-items-center mb-4">
              <b-icon icon="cash-multiple" type="is-danger" size="is-large" class="mr-3" />
              <h2 class="title is-4 has-text-white mb-0">Caja General</h2>
            </div>
            <p class="has-text-grey-lighter mb-5">Flujo de caja detallado: ingresos, egresos y utilidad neta.</p>
            <b-button 
              type="is-danger" 
              expanded 
              class="is-rounded glass-btn"
              @click="$router.push('/ingresos-egresos')"
            >
              Ver Reporte
            </b-button>
          </div>
        </div>

        <!-- Otros Reportes -->
        <div class="column is-4">
          <div class="report-card glass-dashed">
            <div class="has-text-centered py-5">
              <b-icon icon="plus-circle-outline" size="is-large" class="has-text-grey-light" />
              <p class="has-text-grey mt-2">Próximamente más reportes</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ReportesGenerales',
};
</script>

<style scoped>
.glass-container {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.glass-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 25px;
  height: 100%;
  transition: all 0.3s ease;
}

.glass-card:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.glass-dashed {
  background: transparent;
  border: 2px dashed rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 25px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.glass-btn {
  border: none;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.glass-btn:hover {
  filter: brightness(1.1);
}
</style>
